import { Component, Inject } from '@angular/core'
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-delete-bot-confirm',
  templateUrl: './delete-bot-confirm.component.html',
  styleUrls: ['./delete-bot-confirm.component.scss'],
  standalone: false,
})
export class DeleteBotConfirmComponent {
  public userInput: any
  readonly title: string
  readonly closeLabel: string
  readonly cancelLabel: string
  readonly deleteLabel: string

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    this.title = this.translate.instant('shared.deleteBotConfirm.title')
    this.closeLabel = this.translate.instant('common.close')
    this.cancelLabel = this.translate.instant('common.cancel')
    this.deleteLabel = this.translate.instant('common.delete')
  }

  get confirmMessage(): string {
    return this.translate.instant('shared.deleteBotConfirm.confirmMessage', {
      botName: this.data,
    })
  }

  get typeToConfirm(): string {
    return this.translate.instant('shared.deleteBotConfirm.typeToConfirm')
  }

  get inputPlaceholder(): string {
    return this.translate.instant('shared.deleteBotConfirm.inputPlaceholder', {
      botName: this.data,
    })
  }

  isValid() {
    return this.userInput === this.data
  }
}
